import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createCategory, updateCategory, getAllCategories } from "./CategoryService";

export default function CategoryForm(){
  const [categoryType,setCategoryType]=useState("Expense");
  const [categoryName, setCategoryName] = useState("");
  const {id}=useParams();
  const nav=useNavigate();

  useEffect(()=>{
    if(id) load();
  },[id]);

  const load = async ()=>{
    const all = await getAllCategories();
    const c = all.find(x=>x.id===id);
    if(c){
      setCategoryName(c.categoryName);
      setCategoryType(c.categoryType);

    }
  };

  const submit = async (e)=>{
    e.preventDefault();
    if(id) await updateCategory(id,categoryType,categoryName);
    else await createCategory(categoryType,categoryName);
    nav("/expense/categories");
  };

  return (
    <form className="card stack-form" onSubmit={submit}>
      <h3>{id ? "Edit Category" : "Add Category"}</h3>
      <input value={categoryName} onChange={e=>setCategoryName(e.target.value)} placeholder="Name" />
      <select value={categoryType} onChange={e=>setCategoryType(e.target.value)}>
        <option value="EXPENSE">EXPENSE</option>
        <option value="INCOME">INCOME</option>
      </select>
      <button className="btn btn-primary" type="submit">Save</button>
    </form>
  );
}
